import MobileDrawer from '@c/drawers/MobileDrawer';
import Toggle from '@ui/Toggle';
import { formatCurrency } from '@util/index';
import { isVehicleCategory, ProductDocument } from 'models/product';
import Link from 'next/link';

export const ListingActionsDrawer = ({
  open,
  dismiss,
  product,
  onSmartPricing,
  onPromote,
  onDelete,
  onBump,
}: {
  open: boolean;
  dismiss: () => void;
  product: ProductDocument;
  onSmartPricing: () => void;
  onPromote: () => void;
  onDelete: () => void;
  onBump: () => void;
}) => {
  const hasProductStock = !product.integration_info && !product.out_of_stock;

  return (
    <MobileDrawer show={open} dismiss={dismiss} title="Action" topRounded>
      <div className="flex flex-col pb-8">
        {hasProductStock && !product.is_auction && !isVehicleCategory(product.category) ? (
          <div className="mx-8 flex items-center justify-between border-b border-[#d9d9d9] py-6">
            <div className="flex flex-col items-start gap-2">
              <span className="text-body-md font-medium">Smart Pricing</span>
              {Boolean(product.floor_price) ? (
                <span className="rounded-[6px] bg-[#f9e8e8] px-4 py-1 text-body-sm font-medium text-brand-secondary">
                  Floor Price: {formatCurrency(product.floor_price!)}
                </span>
              ) : null}
            </div>
            <Toggle
              enabled={Boolean(product.floor_price)}
              onChange={onSmartPricing}
            />
          </div>
        ) : null}
        {hasProductStock && !product.is_auction && !isVehicleCategory(product.category) ? (
          <button
            type="button"
            className="px-8 py-6 text-left text-body-md font-medium"
            onClick={onPromote}
          >
            Promote
          </button>
        ) : null}
        {hasProductStock ? (
          <Link
            href={`/edit-listing/${product.id}`}
            className="px-8 py-6 text-body-md font-medium"
          >
            Edit
          </Link>
        ) : null}
        <Link
          href={{
            pathname: '/create-listing/',
            query: { id: product.id, step: 3 },
          }}
          className="px-8 py-6 text-body-md font-medium"
        >
          Duplicate
        </Link>
        {isVehicleCategory(product.category) && product.bumps > 0 ? (
          <button
            type="button"
            className="px-8 py-6 text-left text-body-md font-medium"
            onClick={onBump}
          >
            Bump
          </button>
        ) : null}
        <button
          type="button"
          className="px-8 py-6 text-left text-body-md font-medium text-brand-secondary"
          onClick={onDelete}
        >
          Delete
        </button>
      </div>
    </MobileDrawer>
  );
};
